<template>
	<div>
		<div class="form-row">
			<div class="form-group col-md-12">
		        <label>Tag</label>
		        <select-two 
		        	:options="tags" 
		        	:formId="name+'tag_id'"
		        	:valueDefault="dados.tags"
		        	@selected="setTagId"
		        	@searching="getTags"
		        	arrayValue="nome">
		        </select-two>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados),
				tags: []
			}
		},
		created(){
			this.getTags();
		},
		methods : {
			getTags(pesquisa=''){
				axios.get(this.$url+'/api/adm/tags/list?pesquisa='+pesquisa)
	            .then(response => {
	                this.tags = response.data.data.data
	            })
			},
			setTagId(valor){
				this.dados.tag_id = valor.id;
			},
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
